import React from 'react';
import styled from 'styled-components';
import Button from '../components/common/Button';
import Card from '../components/common/Card';
import FAQ from '../components/common/FAQ';

// Imagens temporárias (serão substituídas por imagens reais)
const resourcesImage = 'https://via.placeholder.com/600x400?text=Resources';

const ResourcesPage = () => {
  const [activeFAQ, setActiveFAQ] = React.useState(0);
  
  const toggleFAQ = (index) => {
    setActiveFAQ(activeFAQ === index ? null : index);
  };
  
  return (
    <div>
      {/* Hero Section */}
      <ResourcesHero>
        <ResourcesHeroContent>
          <ResourcesHeroTitle>Recursos e Conhecimento</ResourcesHeroTitle>
          <ResourcesHeroSubtitle>
            Explore nossos recursos para maximizar o valor da sua experiência com a Leadfy
          </ResourcesHeroSubtitle>
        </ResourcesHeroContent>
      </ResourcesHero>

      {/* Resources Categories Section */}
      <Section>
        <SectionTitle>Recursos para Equipes de CX</SectionTitle>
        <SectionDescription>
          Descubra insights, melhores práticas e histórias de sucesso para aprimorar sua estratégia de experiência do cliente.
        </SectionDescription>
        
        <ResourcesGrid>
          <ResourceCard>
            <ResourceIcon>📝</ResourceIcon>
            <ResourceTitle>Blog</ResourceTitle>
            <ResourceDescription>
              Nosso blog apresenta os mais recentes insights, tendências e melhores práticas em IA para CX.
            </ResourceDescription>
            <ResourceLink href="/blog">Explorar Blog</ResourceLink>
          </ResourceCard>
          
          <ResourceCard>
            <ResourceIcon>🎥</ResourceIcon>
            <ResourceTitle>Webinars</ResourceTitle>
            <ResourceDescription>
              Webinars educacionais para ajudar equipes de CX a maximizar o valor da IA.
            </ResourceDescription>
            <ResourceLink href="/webinars">Ver Webinars</ResourceLink>
          </ResourceCard>
          
          <ResourceCard>
            <ResourceIcon>📊</ResourceIcon>
            <ResourceTitle>Relatórios</ResourceTitle>
            <ResourceDescription>
              Relatórios detalhados e pesquisas sobre o estado da IA em experiência do cliente.
            </ResourceDescription>
            <ResourceLink href="/reports">Baixar Relatórios</ResourceLink>
          </ResourceCard>
          
          <ResourceCard>
            <ResourceIcon>📚</ResourceIcon>
            <ResourceTitle>Guias</ResourceTitle>
            <ResourceDescription>
              Guias passo a passo para implementar e otimizar soluções de IA para CX.
            </ResourceDescription>
            <ResourceLink href="/guides">Ler Guias</ResourceLink>
          </ResourceCard>
          
          <ResourceCard>
            <ResourceIcon>👥</ResourceIcon>
            <ResourceTitle>Histórias de Clientes</ResourceTitle>
            <ResourceDescription>
              Veja como outras equipes estão encontrando sucesso com a Leadfy.
            </ResourceDescription>
            <ResourceLink href="/customer-stories">Ver Histórias</ResourceLink>
          </ResourceCard>
          
          <ResourceCard>
            <ResourceIcon>❓</ResourceIcon>
            <ResourceTitle>FAQs</ResourceTitle>
            <ResourceDescription>
              Respostas para as perguntas mais frequentes sobre a Leadfy.
            </ResourceDescription>
            <ResourceLink href="/faqs">Ver FAQs</ResourceLink>
          </ResourceCard>
        </ResourcesGrid>
      </Section>

      {/* Featured Blog Posts Section */}
      <Section background="light">
        <SectionTitle>Artigos em Destaque</SectionTitle>
        <SectionDescription>
          Confira nossos artigos mais recentes e populares sobre IA para experiência do cliente.
        </SectionDescription>
        
        <BlogGrid>
          <BlogPost>
            <BlogImage src="https://via.placeholder.com/400x250?text=Blog+Post+1" alt="Blog Post 1" />
            <BlogCategory>IA para CX</BlogCategory>
            <BlogTitle>Como a IA Agêntica Está Transformando o Atendimento ao Cliente</BlogTitle>
            <BlogExcerpt>
              Descubra como a IA agêntica está revolucionando a forma como as empresas interagem com seus clientes...
            </BlogExcerpt>
            <BlogMeta>
              <BlogAuthor>Por Maria Silva</BlogAuthor>
              <BlogDate>15 de Maio, 2025</BlogDate>
            </BlogMeta>
            <BlogLink href="/blog/ai-transforming-customer-service">Ler Artigo</BlogLink>
          </BlogPost>
          
          <BlogPost>
            <BlogImage src="https://via.placeholder.com/400x250?text=Blog+Post+2" alt="Blog Post 2" />
            <BlogCategory>Melhores Práticas</BlogCategory>
            <BlogTitle>5 Estratégias para Aumentar a Taxa de Autoatendimento</BlogTitle>
            <BlogExcerpt>
              Implementar estas cinco estratégias pode ajudar sua empresa a aumentar significativamente a taxa de autoatendimento...
            </BlogExcerpt>
            <BlogMeta>
              <BlogAuthor>Por João Santos</BlogAuthor>
              <BlogDate>10 de Maio, 2025</BlogDate>
            </BlogMeta>
            <BlogLink href="/blog/increase-self-service-rate">Ler Artigo</BlogLink>
          </BlogPost>
          
          <BlogPost>
            <BlogImage src="https://via.placeholder.com/400x250?text=Blog+Post+3" alt="Blog Post 3" />
            <BlogCategory>Estudo de Caso</BlogCategory>
            <BlogTitle>Como a Empresa XYZ Reduziu o Tempo de Resposta em 55%</BlogTitle>
            <BlogExcerpt>
              Veja como a Empresa XYZ implementou a Leadfy e conseguiu reduzir drasticamente o tempo de resposta...
            </BlogExcerpt>
            <BlogMeta>
              <BlogAuthor>Por Ana Oliveira</BlogAuthor>
              <BlogDate>5 de Maio, 2025</BlogDate>
            </BlogMeta>
            <BlogLink href="/blog/xyz-case-study">Ler Artigo</BlogLink>
          </BlogPost>
        </BlogGrid>
        
        <CenteredButton>
          <Button variant="secondary">Ver Todos os Artigos</Button>
        </CenteredButton>
      </Section>

      {/* Upcoming Webinars Section */}
      <Section>
        <SectionTitle>Webinars Próximos</SectionTitle>
        <SectionDescription>
          Registre-se para nossos próximos webinars e aprenda com especialistas em IA para CX.
        </SectionDescription>
        
        <WebinarsGrid>
          <WebinarCard>
            <WebinarDate>
              <WebinarDay>15</WebinarDay>
              <WebinarMonth>JUN</WebinarMonth>
            </WebinarDate>
            <WebinarContent>
              <WebinarTitle>O Futuro da IA Agêntica em Atendimento ao Cliente</WebinarTitle>
              <WebinarDetails>
                <WebinarTime>14:00 - 15:00 BRT</WebinarTime>
                <WebinarSpeaker>Com Dr. Carlos Mendes, Diretor de IA</WebinarSpeaker>
              </WebinarDetails>
              <WebinarDescription>
                Neste webinar, discutiremos as tendências emergentes em IA agêntica e como elas estão moldando o futuro do atendimento ao cliente.
              </WebinarDescription>
              <Button variant="secondary">Registrar-se</Button>
            </WebinarContent>
          </WebinarCard>
          
          <WebinarCard>
            <WebinarDate>
              <WebinarDay>22</WebinarDay>
              <WebinarMonth>JUN</WebinarMonth>
            </WebinarDate>
            <WebinarContent>
              <WebinarTitle>Implementando IA em Sua Estratégia de CX: Um Guia Prático</WebinarTitle>
              <WebinarDetails>
                <WebinarTime>11:00 - 12:00 BRT</WebinarTime>
                <WebinarSpeaker>Com Fernanda Lima, Gerente de Sucesso do Cliente</WebinarSpeaker>
              </WebinarDetails>
              <WebinarDescription>
                Aprenda estratégias práticas para implementar soluções de IA em sua estratégia de experiência do cliente.
              </WebinarDescription>
              <Button variant="secondary">Registrar-se</Button>
            </WebinarContent>
          </WebinarCard>
        </WebinarsGrid>
        
        <CenteredButton>
          <Button variant="secondary">Ver Todos os Webinars</Button>
        </CenteredButton>
      </Section>

      {/* Customer Stories Section */}
      <Section background="light">
        <SectionTitle>Histórias de Clientes</SectionTitle>
        <SectionDescription>
          Veja como outras empresas estão transformando sua experiência do cliente com a Leadfy.
        </SectionDescription>
        
        <StoriesGrid>
          <StoryCard>
            <StoryLogo src="https://via.placeholder.com/150x50?text=Logo+1" alt="Company 1 Logo" />
            <StoryTitle>"A Leadfy revolucionou nossa abordagem de atendimento ao cliente"</StoryTitle>
            <StoryQuote>
              "Desde que implementamos a Leadfy, vimos uma melhoria de 40% na satisfação do cliente e uma redução de 55% no tempo de resposta."
            </StoryQuote>
            <StoryAuthor>Maria Silva, Diretora de CX na Empresa ABC</StoryAuthor>
            <StoryLink href="/customer-stories/abc-company">Ler História Completa</StoryLink>
          </StoryCard>
          
          <StoryCard>
            <StoryLogo src="https://via.placeholder.com/150x50?text=Logo+2" alt="Company 2 Logo" />
            <StoryTitle>"Aumentamos nossa taxa de autoatendimento para 65% com a Leadfy"</StoryTitle>
            <StoryQuote>
              "A capacidade da Leadfy de entender e resolver problemas complexos de clientes nos permitiu automatizar uma parte significativa de nossas interações."
            </StoryQuote>
            <StoryAuthor>João Santos, CTO na Empresa XYZ</StoryAuthor>
            <StoryLink href="/customer-stories/xyz-company">Ler História Completa</StoryLink>
          </StoryCard>
        </StoriesGrid>
        
        <CenteredButton>
          <Button variant="secondary">Ver Todas as Histórias</Button>
        </CenteredButton>
      </Section>

      {/* CTA Section */}
      <Section>
        <SectionTitle>Pronto para Transformar Sua Experiência do Cliente?</SectionTitle>
        <SectionDescription>
          Descubra como a Leadfy pode ajudar sua empresa a oferecer um atendimento ao cliente mais rápido, mais inteligente e mais humano.
        </SectionDescription>
        
        <CenteredButton>
          <Button size="large">Solicite uma Demo</Button>
        </CenteredButton>
      </Section>
    </div>
  );
};

// Styled Components
const ResourcesHero = styled.section`
  background-color: var(--primary-dark);
  padding: var(--spacing-xxl) 0;
  color: var(--white);
`;

const ResourcesHeroContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
  padding: 0 var(--spacing-lg);
`;

const ResourcesHeroTitle = styled.h1`
  font-size: var(--font-size-4xl);
  margin-bottom: var(--spacing-lg);
`;

const ResourcesHeroSubtitle = styled.p`
  font-size: var(--font-size-xl);
  opacity: 0.9;
`;

const Section = styled.section`
  padding: var(--spacing-xxl) 0;
  background-color: ${props => props.background === 'light' ? 'var(--light-bg)' : 'var(--white)'};
`;

const SectionTitle = styled.h2`
  font-size: var(--font-size-3xl);
  text-align: center;
  margin-bottom: var(--spacing-lg);
  color: var(--primary-dark);
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const SectionDescription = styled.p`
  font-size: var(--font-size-lg);
  text-align: center;
  margin-bottom: var(--spacing-xl);
  color: var(--text-secondary);
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const ResourcesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--spacing-lg);
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-lg);
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ResourceCard = styled.div`
  background-color: var(--white);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-md);
  padding: var(--spacing-lg);
  text-align: center;
  transition: transform var(--transition-normal), box-shadow var(--transition-normal);
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: var(--shadow-lg);
  }
`;

const ResourceIcon = styled.div`
  font-size: 3rem;
  margin-bottom: var(--spacing-md);
`;

const ResourceTitle = styled.h3`
  font-size: var(--font-size-xl);
  margin-bottom: var(--spacing-md);
  color: var(--primary-dark);
`;

const ResourceDescription = styled.p`
  font-size: var(--font-size-md);
  color: var(--text-secondary);
  margin-bottom: var(--spacing-lg);
`;

const ResourceLink = styled.a`
  color: var(--primary);
  font-weight: 600;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`;

const BlogGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--spacing-lg);
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-lg);
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const BlogPost = styled.div`
  background-color: var(--white);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-md);
  overflow: hidden;
  transition: transform var(--transition-normal), box-shadow var(--transition-normal);
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: var(--shadow-lg);
  }
`;

const BlogImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
`;

const BlogCategory = styled.div`
  font-size: var(--font-size-sm);
  color: var(--primary);
  font-weight: 600;
  margin: var(--spacing-md) var(--spacing-md) 0;
`;

const BlogTitle = styled.h3`
  font-size: var(--font-size-lg);
  margin: var(--spacing-sm) var(--spacing-md);
  color: var(--primary-dark);
`;

const BlogExcerpt = styled.p`
  font-size: var(--font-size-md);
  color: var(--text-secondary);
  margin: var(--spacing-sm) var(--spacing-md);
`;

const BlogMeta = styled.div`
  display: flex;
  justify-content: space-between;
  margin: var(--spacing-md);
  font-size: var(--font-size-sm);
  color: var(--text-light);
`;

const BlogAuthor = styled.span``;

const BlogDate = styled.span``;

const BlogLink = styled.a`
  display: block;
  text-align: center;
  padding: var(--spacing-md);
  background-color: var(--light-bg);
  color: var(--primary);
  font-weight: 600;
  text-decoration: none;
  
  &:hover {
    background-color: var(--primary-light);
    color: var(--white);
  }
`;

const WebinarsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--spacing-lg);
  max-width: 900px;
  margin: 0 auto;
  padding: 0 var(--spacing-lg);
`;

const WebinarCard = styled.div`
  display: flex;
  background-color: var(--white);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-md);
  overflow: hidden;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const WebinarDate = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--primary);
  color: var(--white);
  padding: var(--spacing-lg);
  min-width: 100px;
  
  @media (max-width: 768px) {
    padding: var(--spacing-md);
  }
`;

const WebinarDay = styled.div`
  font-size: var(--font-size-3xl);
  font-weight: 700;
`;

const WebinarMonth = styled.div`
  font-size: var(--font-size-md);
  font-weight: 600;
`;

const WebinarContent = styled.div`
  flex: 1;
  padding: var(--spacing-lg);
`;

const WebinarTitle = styled.h3`
  font-size: var(--font-size-xl);
  margin-bottom: var(--spacing-md);
  color: var(--primary-dark);
`;

const WebinarDetails = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: var(--spacing-md);
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: var(--spacing-xs);
  }
`;

const WebinarTime = styled.div`
  font-size: var(--font-size-md);
  color: var(--text-secondary);
`;

const WebinarSpeaker = styled.div`
  font-size: var(--font-size-md);
  color: var(--text-secondary);
`;

const WebinarDescription = styled.p`
  font-size: var(--font-size-md);
  color: var(--text-secondary);
  margin-bottom: var(--spacing-lg);
`;

const StoriesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--spacing-lg);
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-lg);
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const StoryCard = styled.div`
  background-color: var(--white);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-md);
  padding: var(--spacing-lg);
  transition: transform var(--transition-normal), box-shadow var(--transition-normal);
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: var(--shadow-lg);
  }
`;

const StoryLogo = styled.img`
  height: 40px;
  margin-bottom: var(--spacing-md);
`;

const StoryTitle = styled.h3`
  font-size: var(--font-size-xl);
  margin-bottom: var(--spacing-md);
  color: var(--primary-dark);
`;

const StoryQuote = styled.blockquote`
  font-size: var(--font-size-md);
  color: var(--text-secondary);
  margin-bottom: var(--spacing-md);
  font-style: italic;
  position: relative;
  padding-left: var(--spacing-md);
  
  &::before {
    content: '"';
    position: absolute;
    left: 0;
    top: -10px;
    font-size: 2rem;
    color: var(--primary-light);
  }
`;

const StoryAuthor = styled.div`
  font-size: var(--font-size-md);
  color: var(--text-secondary);
  margin-bottom: var(--spacing-md);
`;

const StoryLink = styled.a`
  color: var(--primary);
  font-weight: 600;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`;

const CenteredButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: var(--spacing-xl);
`;

export default ResourcesPage;
